import React from 'react';

import { Button } from 'shadcn/components/ui/Button';
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
} from 'shadcn/components/ui/Dialog';

export function TemperatureConflictDialog({
    description = 'This item’s storage temperature zone differs from the current input values. Please confirm the min/max temperature requirements.',
    isOpen,
    onClose,
    storageTempZone = '',
    title = 'Temperature requirement mismatch',
}) {
    const handleOpenChange = (nextOpen) => {
        if (!nextOpen && typeof onClose === 'function') {
            onClose();
        }
    };

    return (
        <Dialog open={isOpen} onOpenChange={handleOpenChange}>
            <DialogContent>
                <DialogHeader>
                    <DialogTitle>{title}</DialogTitle>
                    {description ? <DialogDescription>{description}</DialogDescription> : null}
                    {storageTempZone ? (
                        <DialogDescription>{`This item has a storage temp zone of ${storageTempZone}.`}</DialogDescription>
                    ) : null}
                </DialogHeader>
                <DialogFooter>
                    <Button type="button" onClick={onClose}>
                        OK
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}

TemperatureConflictDialog.displayName = 'TemperatureConflictDialog';
